export default __webpack_public_path__ + "static/media/OGNLogo.35484d53.jpg";